var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAddUser(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_287_1921)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.66667 8.16668C9.69171 8.16668 11.3333 6.52505 11.3333 4.50001C11.3333 2.47497 9.69171 0.833344 7.66667 0.833344C5.64162 0.833344 4 2.47497 4 4.50001C4 6.52505 5.64162 8.16668 7.66667 8.16668Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.62065 14.508C7.92531 13.764 7.49998 12.7647 7.49998 11.6667C7.49998 10.546 7.94331 9.52867 8.66331 8.77933C8.33865 8.75467 8.00531 8.74133 7.66665 8.74133C5.45198 8.74133 3.49131 9.29533 2.27398 10.1253C1.34531 10.7587 0.833313 11.5633 0.833313 12.408V13.3753C0.833313 13.6753 0.952646 13.964 1.16531 14.1767C1.37798 14.3887 1.66598 14.5087 1.96665 14.5087L8.62065 14.508Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.6666 8.16669C9.73463 8.16669 8.16663 9.73469 8.16663 11.6667C8.16663 13.5987 9.73463 15.1667 11.6666 15.1667C13.5986 15.1667 15.1666 13.5987 15.1666 11.6667C15.1666 9.73469 13.5986 8.16669 11.6666 8.16669ZM12.1666 11.1667V10.5C12.1666 10.224 11.9426 10 11.6666 10C11.3906 10 11.1666 10.224 11.1666 10.5V11.1667H10.5C10.224 11.1667 9.99996 11.3907 9.99996 11.6667C9.99996 11.9427 10.224 12.1667 10.5 12.1667H11.1666V12.8334C11.1666 13.1094 11.3906 13.3334 11.6666 13.3334C11.9426 13.3334 12.1666 13.1094 12.1666 12.8334V12.1667H12.8333C13.1093 12.1667 13.3333 11.9427 13.3333 11.6667C13.3333 11.3907 13.1093 11.1667 12.8333 11.1667H12.1666Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_287_1921"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddUser);
export default __webpack_public_path__ + "static/media/add-user.4d473c1744e98a6ad02d695eafab4039.svg";
export { ForwardRef as ReactComponent };